// extracted by mini-css-extract-plugin
export default {"cardInfo":"CardInfo_cardInfo__PeUvE"};